<script>
export default {
  filters: {},
  props: {
    products: {
      type: Array,
      required: true,
    },
    category: {
      type: Array,
      required: true,
    },
    prices: {
      type: Array,
      required: true,
    },
    defaultValue: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      activeNames: [],
      activeTab: 'primary',
      activeTabList: [],
    }
  },
  computed: {
    submitData: {
      get() {
        return this.defaultValue
      },
      set(value) {
        this.$emit('update:defaultValue', value)
      },
    },
    isEditMode() {
      return !!this.defaultValue.groupOrdering
    },
    expandAll() {
      return this.defaultValue.prepaids.map((i, index) => {
        return `${index}`
      })
    },
    // prepaidRules() {
    //   return {
    //     price: [
    //       {
    //         type: 'number',
    //         min: 0,
    //         message: '請輸入數字'
    //       }
    //     ],

    //   }
    // },
    // filterSizes() {
    //   return this.category.find((item) => {
    //     return item.id === this.submitData.categoryId
    //   }).children
    // },
  },
  watch: {
    'submitData.categoryId': {
      handler(value) {
        this.doSetSizes()
      },
    },
    'submitData.prepaids': {
      handler(nvl) {
        this.activeTabList = Array(nvl.length).fill('primary')
      },
      immediate: true,
      deep: true,
    },
  },
  created() {
    // this.submitData.categoryId = 1
    if (!this.isEditMode) {
      this.doSetSizes()
    }
  },
  methods: {
    doSetSizes() {
      const list = this.category.find((item) => {
        return item.id === this.submitData.categoryId
      }).children
      this.submitData.prepaids = list.map((item) => {
        return {
          sizeId: item.id,
          title: item.categoryTitle,
          basePrice: 0,
          price: 0,
          state: 0,
        }
      })
    },
    validate() {
      return this.$refs.form.validate()
    },
    computedCostPrice(data, row) {
      const service = this.prices.find((item) => item.petCategoryId === this.submitData.categoryId && item.title === row.title)
      const price = service?.petSizes.find((pet) => pet.sizeId === data.sizeId)?.prices[0].costPrice ?? '-'
      return price
    },
    switchTab(value, index) {
      this.activeTabList[index] = value
    },
  },
}
</script>

<template>
  <div :class="$style.pageContent">
    <div class="isStylePageContent">
      <h4 class="form-block-title">價格設定</h4>
      <el-form ref="form" :model="submitData" label-position="top">
        <el-collapse :value="expandAll" class="custom-collapse isStyleLimit isStylePrepaidPrices" style="border:0">
          <el-collapse-item v-for="(item, index) in submitData.prepaids" :key="index" :name="`${index}`">
            <div slot="title" class="el-collapse-title d-flex align-items-center">
              <span v-if="isEditMode">{{ item.sizeTitle }}</span>
              <span v-else>{{ item.title }}</span>
              <div class="ml-auto d-flex align-items-center rightBox">
                <span class="mr-3 d-lg-inline d-none text-text-light">
                  <span v-if="item.basePrice">原價：{{ item.basePrice }}元/</span> 售價：{{ item.price }}元
                </span>
                <el-form-item prop="state">
                  <el-switch v-model="item.state" active-text="開放" inactive-text="關閉" :active-value="1" :inactive-value="0" @click.stop.native></el-switch>
                </el-form-item>
              </div>
            </div>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item prop="basePrice" label="原價">
                  <el-input v-model.number="item.basePrice">
                    <span slot="suffix" style="margin-right:10px">元</span>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :prop="`prepaids[${index}].price`" :rules="{ type: 'number', min: 0, message: '請輸入數字', trigger: 'blur' }" label="售價">
                  <el-input v-model.number="item.price">
                    <span slot="suffix" style="margin-right:10px">元</span>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item prop="basePrice">
                  <span class="mr-2">成本價</span>
                  <span class="text-muted" style="font-size: 10px;">註：填寫成本價可能加數據分析計算精準度</span>
                  <el-tabs v-model="activeTabList[index]" stretch class="mb-2" @tab-click="(tab) => switchTab(tab.name, index)">
                    <el-tab-pane label="購買項目" name="primary"></el-tab-pane>
                    <el-tab-pane label="贈送項目" name="bonus"></el-tab-pane>
                  </el-tabs>
                  <!-- 購買項目攤提 -->
                  <el-table v-if="activeTab === 'primary'" :data="item.prices">
                    <el-table-column v-slot="{ row }" label="項目" min-width="180">
                      <div>
                        <p>{{ row.title }}</p>
                        <p>原價{{ item.basePrice }}元/售價{{ item.price }}元</p>
                      </div>
                    </el-table-column>
                    <el-table-column v-slot="{ row }" label="服務成本價" prop="storeTitle" min-width="100">
                      <div>{{ computedCostPrice(item, row) }}</div>
                    </el-table-column>
                    <el-table-column v-slot="{ row, $index }" label="攤提費用" prop="storeTitle" min-width="180">
                      <el-input v-model.number="item.sharePrices[$index].sharePrice">
                        <span slot="suffix" style="margin-right:10px">元</span>
                      </el-input>
                    </el-table-column>
                  </el-table>
                  <!-- 贈送項目攤提 -->
                  <el-table v-else :data="item.bonusPrices">
                    <el-table-column v-slot="{ row }" label="項目" min-width="180">
                      <div>
                        <p>{{ row.title }}</p>
                        <p>原價{{ item.basePrice }}元/售價{{ item.price }}元</p>
                      </div>
                    </el-table-column>
                    <el-table-column v-slot="{ row }" label="服務成本價" prop="storeTitle" min-width="100">
                      <div>{{ computedCostPrice(item, row) }}</div>
                    </el-table-column>
                    <el-table-column v-slot="{ row, $index }" label="攤提費用" prop="storeTitle" min-width="180">
                      <el-input v-model.number="item.bonusSharePrices[$index].sharePrice">
                        <span slot="suffix" style="margin-right:10px">元</span>
                      </el-input>
                    </el-table-column>
                  </el-table>
                </el-form-item>
              </el-col>
            </el-row>
          </el-collapse-item>
        </el-collapse>
      </el-form>
    </div>
  </div>
</template>
<style lang="scss" module>
@import '@src/design/layout_detail_steps.scss';

.switch {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0;
  padding-bottom: 5px;
  border-bottom: $color-border-base 1px solid;

  :global {
    .el-form-item {
      margin-bottom: 0;
    }
  }
}
</style>
